import type { GameState } from '../game/GameState.js';
import type { ChessSnapshot } from '../network/protocol.js';

export interface SnapshotStep {
  readonly state: GameState;
  /** True when the snapshot is the held game plus one move. */
  readonly moved: boolean;
}

/**
 * The cheap way to adopt a snapshot: it is the game we hold, or that game
 * plus one move. Null when it is anything else (a resume, a new game, a
 * correction), which the caller answers by replaying the snapshot from
 * scratch.
 */
export function stepSnapshot(prev: GameState, snapshot: ChessSnapshot): SnapshotStep | null {
  if (snapshot.startFen !== prev.startFen) return null;
  if (prev.isOver && snapshot.outcome === null) return null;
  const mine = prev.uciMoves;
  const extra = snapshot.moves.length - mine.length;
  if (extra < 0 || extra > 1 || !mine.every((uci, i) => uci === snapshot.moves[i])) return null;
  let state: GameState | null = prev;
  if (extra === 1) state = prev.playUci(snapshot.moves[mine.length] ?? '');
  if (state === null) return null;
  if (snapshot.outcome !== null && state.outcome === null) state = state.conclude(snapshot.outcome);
  return { state, moved: extra === 1 };
}
